import { Enum, ProjectType } from '../../common/constants'
import { LegacyWorkareaData } from '../../domain/jobs/jobs'
import { jobRouteBase } from './jobDetailModel'

export const JobReportTypes = {
  JobReport: 'job-report',
  ItemsSummary: 'items-summary'
} as const
export type JobReportType = Enum<typeof JobReportTypes>

export type PrintWorkarea = {
  id: number
  name: string
  isOnHold: boolean
  print: boolean
}

export const buildPrintWorkareas = (workareas: LegacyWorkareaData[]): PrintWorkarea[] => {
  return workareas.map(workarea => ({
    id: workarea.id,
    name: workarea.name,
    isOnHold: workarea.isOnHold,
    print: !workarea.isOnHold
  }))
}

/** The endpoint takes a `print-area-{id}` -> boolean map and prints the true ones. */
export const buildPrintWorkareasRequest = (printWorkareas: PrintWorkarea[]): Record<string, boolean> => {
  const request: Record<string, boolean> = {}
  printWorkareas.forEach(workarea => {
    request[`print-area-${workarea.id}`] = workarea.print
  })
  return request
}

export const togglePrintWorkarea = (
  printWorkareas: PrintWorkarea[],
  workareaId: number,
  print: boolean
): PrintWorkarea[] => {
  return printWorkareas.map(workarea => workarea.id === workareaId ? { ...workarea, print } : workarea)
}

/**
 * The route segment is only a regex constraint on the endpoint — the report is
 * built from the job id and workarea ids — but it still has to be one of
 * estimates|projects|tickets|maintenance.
 */
export const jobPrintRouteSegment = (jobType: ProjectType): string => jobRouteBase(jobType)
